import { RegexValidator } from './RegexValidator'

//eslint-disable-next-line
export const NUMBER_REGEX = /^\-?\d+(\.\d+)?$/

export class NumberValidator extends RegexValidator {
    constructor() {
        super(NUMBER_REGEX, 'validations.number')
    }
}

export const NUMBER_VALIDATOR = new NumberValidator()
